import {
    Box,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tooltip,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
// import SwitchToggle from "../../components/SwitchToggle";
import Pagination from "../../components/Panigation";
import { useGetPermissionsQuery, useDeletePermissionMutation, useGetSubAdminsQuery } from "../../service/features/api";
import moment from "moment";
import { toast } from "react-toastify";
import DeleteConfirmModal from "../../Modals/DeleteConfirmModal";

const RolesList = ({ search }: { search: string }) => {
    const navigate = useNavigate();
    const [page, setPage] = useState(1);
    const limit = 10;

    const { data: permissionsData, isLoading } = useGetPermissionsQuery({
        search,
        page,
        limit
    });

    const { data: subAdminsData } = useGetSubAdminsQuery({
        search: "",
        page: 1,
        limit: 1000
    });

    const [deletePermission] = useDeletePermissionMutation();
    // const [updateStatus] = useUpdatePermissionStatusMutation();

    const roles = permissionsData?.data?.data || [];
    const subAdmins = subAdminsData?.data?.data || [];
    const totalCount = permissionsData?.data?.paginator?.itemCount || 0;
    const totalPages = permissionsData?.data?.paginator?.pageCount || 1;

    // Delete Confirmation State
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [roleIdToDelete, setRoleIdToDelete] = useState<string | null>(null);
    const [isDeleting, setIsDeleting] = useState(false);

    // const handleStatusChange = async (id: string, isBlocked: boolean) => {
    //     try {
    //         await updateStatus({ id, isBlocked }).unwrap();
    //         toast.success("Status updated successfully");
    //     } catch (error) {
    //         toast.error("Failed to update status");
    //     }
    // };

    const handleDelete = (id: string) => {
        const isAssigned = subAdmins.some((admin: any) => admin.permission?._id === id);
        if (isAssigned) {
            toast.warning("This role is assigned to a subadmin and cannot be deleted");
            return;
        }
        setRoleIdToDelete(id);
        setIsDeleteModalOpen(true);
    };

    const confirmDelete = async () => {
        if (!roleIdToDelete) return;
        setIsDeleting(true);
        try {
            await deletePermission(roleIdToDelete).unwrap();
            toast.success("Role deleted successfully");
            setIsDeleteModalOpen(false);
            setRoleIdToDelete(null);
        } catch (error: any) {
            console.error("Failed to delete role:", error);
            toast.warning(error?.data?.message || "Failed to delete role");
        } finally {
            setIsDeleting(false);
        }
    };

    if (isLoading) return <div className="loading_state">Loading...</div>;

    return (
        <>
            <TableContainer className="table_container">
                <Table>
                    <TableHead>
                        <TableRow hover>
                            <TableCell>Role Name</TableCell>
                            <TableCell>Created Date</TableCell>
                            <TableCell>Permission Module</TableCell>
                            {/* <TableCell>Disable/Enable</TableCell> */}
                            <TableCell>Action</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {roles.map((row: any) => (
                            <TableRow hover key={row._id}>
                                <TableCell>
                                    <a
                                        href="/manage-subadmin/roles/detail"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            navigate("/manage-subadmin/roles/detail", { state: { id: row._id } });
                                        }}
                                        className="user_block click_action"
                                    >
                                        <p>
                                            <b>{row.name}</b>
                                        </p>
                                    </a>

                                </TableCell>
                                 <TableCell>{moment(row.createdAt).format("DD MMMM YYYY")}</TableCell>
                                <TableCell>
                                    <Tooltip title={row.permission?.map((p: any) => p.label).join(", ")} arrow>
                                        <span className="permission_labels">
                                            {row.permission?.slice(0, 3).map((p: any) => p.label).join(", ")}
                                            {row.permission?.length > 3 ? "..." : ""}
                                        </span>
                                    </Tooltip>
                                </TableCell>
                                {/* <TableCell>
                                    <SwitchToggle 
                                        checked={!row.isBlocked} 
                                        onChange={(e) => handleStatusChange(row._id, !e.target.checked)}
                                    />
                                </TableCell> */}
                                <TableCell>
                                    <div className="table_actions v2">
                                        <Tooltip title="View" arrow>
                                            <Box>
                                                <IconButton
                                                    onClick={() => navigate("/manage-subadmin/roles/detail", { state: { id: row._id } })}
                                                >
                                                    <img src="/static/images/eye_icon.svg" alt="View" />
                                                </IconButton>
                                            </Box>
                                        </Tooltip>
                                        <Tooltip title="Edit" arrow>
                                            <Box>
                                                <IconButton
                                                    onClick={() => navigate("/manage-subadmin/roles/add", { state: { id: row._id } })}
                                                >
                                                    <img src="/static/images/edit2_icon.svg" alt="Edit" />
                                                </IconButton>
                                            </Box>
                                        </Tooltip>
                                        <Tooltip title="Delete" arrow>
                                            <Box>
                                                <IconButton onClick={() => handleDelete(row._id)}>
                                                    <img src="/static/images/trash2_icon.svg" alt="Delete" />
                                                </IconButton>
                                            </Box>
                                        </Tooltip>
                                    </div>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <Pagination
                module={roles}
                page={page}
                totalPages={totalPages}
                totalCount={totalCount}
                setPage={setPage}
                onPageChange={(p) => setPage(p)}
            />

            <DeleteConfirmModal
                open={isDeleteModalOpen}
                onClose={() => setIsDeleteModalOpen(false)}
                onConfirm={confirmDelete}
                title="Delete Role"
                message="Are you sure you want to delete this role?"
                isLoading={isDeleting}
            />
        </>
    );
};

export default RolesList;
